import React from 'react'

const Error404 = () => {
    return (
        <div>
            <h1>Page Not Founds</h1>
        </div>
    )
}

export default Error404